import { StyleSheet } from 'react-native';

export const colors = {
  primary: '#5F9EA0',
  secondary: '#B0C4DE',
  background: '#F5F5F5',
  white: '#FFFFFF',
  text: '#333333',
  textLight: '#666666',
  error: '#FF6B6B',
  success: '#4BB543',
  warning: '#FFB347',
  border: '#E5E5E5',
};

export const globalStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
    padding: 20,
  },
  centerContent: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: colors.text,
    marginBottom: 20,
  },
  errorText: {
    color: colors.error,
    fontSize: 14,
    marginBottom: 10,
  },
  link: {
    color: colors.primary,
    textDecorationLine: 'underline',
    marginTop: 15,
  },
});